import React, { useLayoutEffect, useRef, useState } from "react";

import { ReactComponent as AIGenerateIcon } from "../../../../assets/images/ai-generate-icon.svg";
import { getTranslation } from "../../../../helpers/getLanguage";
import CustomInput from "../../../inputs/CustomInput";
import CustomTextarea from "../../../inputs/CustomTextarea";
import { ImagesCarousel } from "../../../inputs/ImagesCarousel";
import ImageUploader from "../../../inputs/ImageUploader";
import ErrorMessageModal from "../../ErrorMessageModal";
import GenerateImageModal from "../../GenerateImageModal";
import GenerateNamesModal from "../../GenerateNamesModal";
import ImageModal from "../../ImageModal";

const DescribeNewProduct = ({
  selectCurrentReplacementImageFromLibrary,
  removeImageFromLibrary,
  replacement,
  potentialGeneratedImageUrl,
  handleAcceptPotentialImage,
  handleChange,
  uploadInfo,
  newGeneratedImage,
  handleCancelClick,
  handleFileSelect,
  isLoadingImage,
  productType,
  header,
  handleGenerateNames,
  handleGenerateImage,
  openGenerateNameModal,
  closeGenerateNamesModal,
  suggestedNamesForIdeas,
  suggestedLoading,
  addIdeasName,
  isOpenGenerateImageModal,
  closeDialogGenerateImage,
  generatedImage,
}) => {
  const titleRef = useRef(null);
  const [heightOfTitle, setHeightOfTitle] = useState(0);
  const [isOpenImage, setIsOpenImage] = useState(false);

  const [currentModalImage, setCurrentModalImage] = useState(null);
  const [error, setError] = useState({
    openErrorModal: false,
    message: "",
    headerError: "",
  });

  const closeErrorWindow = () => {
    setError({
      openErrorModal: false,
      message: "",
      headerError: "",
    });
  };

  const openImageModal = (newImage) => {
    setCurrentModalImage(newImage);
    setIsOpenImage(true);
  };

  const fileSelectRef = useRef(null);

  useLayoutEffect(() => {
    setHeightOfTitle(titleRef.current.clientHeight);
  }, [header]);

  const getReplacementDescription = (header) => {
    return (
      <p ref={titleRef} style={{ marginTop: heightOfTitle > 73 ? "-30px" : "" }} className="replacement-description">
        {`${getTranslation("REPLACEMENT_DESCRIBE")} ${productType} ${getTranslation("REPLACEMENT_IN_WHICH")}`}
        <u>{header.firstComponent}</u>
        {productType === "process" && (
          <span style={{ marginRight: "10px" }}>{getTranslation("SUBTRACTION_MODAL_HEADER_STEP")}</span>
        )}
        {getTranslation("REPLACEMENT_IS_REPlACED")}
        <u>{header.replacingComponent}</u>
        {productType === "process" && <span>{getTranslation("SUBTRACTION_MODAL_HEADER_STEP")}</span>}
      </p>
    );
  };

  const validateFile = (file) => {
    if (!file || file.size > 2097152) {
      setError({
        openErrorModal: true,
        message: "Uploaded file is too big, max image size is 2 MB",
        headerError: getTranslation("ERROR_MESSAGE_MODAL_HEADER"),
      });
      return false;
    }
    return true;
  };

  const handleFileUpload = (event) => {
    const file = event.target ? event.target.files[0] : event[0];
    if (!validateFile(file)) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const buffer = e.target.result;
      const imageUrl = `data:image/png;base64,${Buffer.from(buffer).toString("base64")}`;
      handleFileSelect(file, imageUrl);
    };
    reader.readAsArrayBuffer(file);
  };

  const isImagesLibraryFull = replacement.imagesLibrary.length > 9;

  const setMaxImageLibraryError = () => {
    setError({
      openErrorModal: true,
      message: (
        <p className="flex-column mt-25px">
          <span style={{ margin: "0" }}>{getTranslation("IMAGE_LIBRARY_MAX_SIZE_ERROR_IMAGES_COUNT")}</span>
          <span>{getTranslation("IMAGE_LIBRARY_MAX_SIZE_ERROR_DELETE")}</span>
        </p>
      ),
      headerError: getTranslation("IMAGE_LIMIT_REACHED"),
    });
  };

  return (
    <>
      <div>{getReplacementDescription(header)}</div>

      <div className="flex replacement-modal-container">
        <CustomTextarea
          value={replacement.comment}
          onChange={handleChange}
          height={287}
          maxHeight={287}
          name="comment"
          label={getTranslation("REPLACEMENT_TAB_DESCRIBE_DESCRIPTION")}
          containerClass="flex-column subtraction-modal-input"
          textareaClass="bgc-white replacement-modal-container__describe"
        />

        <div className="flex-column" style={{ marginTop: "-35px" }}>
          <button
            className="replacement-modal__button-ai replacement-modal__button-ai_name-idea"
            onClick={handleGenerateNames}
          >
            <AIGenerateIcon style={{ marginRight: "10px", width: "18px" }} />
            <span>{getTranslation("GENERATE_IDEAS_NAMES_BUTTON")}</span>
          </button>
          <CustomInput
            labelClass="replacement-modal-container__label"
            value={replacement.ideaName}
            onChange={handleChange}
            name="ideaName"
            label={getTranslation("RATE_IDEA_CUSTOM_INPUT")}
            containerClass="flex-column subtraction-modal-input"
            customInputClass="bgc-white replacement-modal-container__name"
          />

          <div style={{ marginTop: "-26px" }}>
            {replacement.imagesLibrary.length > 0 && (
              <>
                <input
                  type="file"
                  ref={fileSelectRef}
                  style={{ display: "none" }}
                  onChange={(e) => handleFileUpload(e)}
                />
                <button
                  className={`replacement-modal__upload-image-button replacement-modal__button-ai
                                        ${isImagesLibraryFull && "replacement-modal__upload-image-button_disabled"}`}
                  onClick={() => (isImagesLibraryFull ? setMaxImageLibraryError() : fileSelectRef.current.click())}
                >
                  {getTranslation("UPLOAD_IMAGES")}
                </button>
              </>
            )}
            <button
              className={`replacement-modal__button-ai 
                                replacement-modal__button-ai_image 
                                ${isImagesLibraryFull && "replacement-modal__button-ai_image-disabled"}`}
              onClick={() => (isImagesLibraryFull ? setMaxImageLibraryError() : handleGenerateImage())}
              style={{ left: replacement.imagesLibrary.length ? "10px" : "95px" }}
            >
              <p>
                <AIGenerateIcon style={{ marginRight: "10px", width: "18px" }} />
                <span>{getTranslation("GENERATE_IMAGES_BUTTON")}</span>
              </p>
              <p>{getTranslation("GENERATE_IMAGES_BUTTON_AI_CREDITS")}</p>
            </button>
            {replacement.imagesLibrary.length ? (
              <ImagesCarousel
                openImageModal={openImageModal}
                imagesLibrary={replacement.imagesLibrary}
                currentImageId={replacement.image.id}
                selectCurrentDependencyImageFromLibrary={selectCurrentReplacementImageFromLibrary}
                startIndex={replacement.imagesLibrary.findIndex((image) => image.id === replacement.image.id)}
                removeImageFromLibrary={removeImageFromLibrary}
              />
            ) : (
              <ImageUploader
                label={getTranslation("DESCRIBE_NEW_SUBTRACTION_ADD_SKETCH")}
                uploadInfo={uploadInfo}
                handleCancelClick={handleCancelClick}
                handleFileSelect={handleFileSelect}
                displayPreview
                isLoadingImage={isLoadingImage}
                height={200}
                maxHeight={200}
                currentProjectImageId={replacement.image.id}
                openImage={() => setIsOpenImage(true)}
                generatedImage={generatedImage}
              />
            )}
          </div>
        </div>
      </div>

      {openGenerateNameModal && (
        <GenerateNamesModal
          closeGenerateNamesModal={closeGenerateNamesModal}
          suggestedNamesForIdeas={suggestedNamesForIdeas}
          suggestedLoading={suggestedLoading}
          addIdeasName={addIdeasName}
        />
      )}

      {isOpenImage && (
        <ImageModal
          closeModal={() => setIsOpenImage(false)}
          imageData={newGeneratedImage.isNew ? newGeneratedImage.urlImage : uploadInfo}
          altImage={getTranslation("IMAGE_MODAL_ALT_SKETCH_IDEA")}
        />
      )}

      {error.openErrorModal && (
        <ErrorMessageModal
          message={error.message}
          closeModalWindow={closeErrorWindow}
          textButton={getTranslation("CONFIRMATION_MODAL_DEFAULT_BUTTON_TEXT")}
          handleButton={closeErrorWindow}
          header={error.headerError}
        />
      )}

      {isOpenGenerateImageModal && (
        <GenerateImageModal
          handleAcceptPotentialImage={handleAcceptPotentialImage}
          closeModalWindow={closeDialogGenerateImage}
          header={getTranslation("OPEN_AI_LOADER_HEADER_IMAGE")}
          message={getTranslation("OPEN_AI_LOADER_IMAGE")}
          imageData={potentialGeneratedImageUrl}
          suggestedLoading={suggestedLoading}
        />
      )}
    </>
  );
};

export default DescribeNewProduct;
